'use client'

import { usePathname } from 'next/navigation'

import { stripLocaleFromPathname } from '../../../lib/routing/routing'

type Props = {
  defaultHeader: React.ReactNode
}

export const PrimaryNavHeaderRoot = ({ defaultHeader }: Props) => {
  const pathname = usePathname()
  const cleanPathname = stripLocaleFromPathname(pathname ?? '')

  // Organization routes with an ID handle their own header in their layout
  // to access B2B-specific logic like dynamic links
  const hasOrganizationId = /^\/organization\/[^/]+/.test(cleanPathname)

  if (hasOrganizationId) return null

  return <>{defaultHeader}</>
}
